import _ from 'lodash';
import { TableColumn } from './DistributionsTable';

export const processedData = (rows: any, columns: TableColumn[]) => {
    const rowGroups: any = [];
    const groupId = _.find(columns, (c) => !!c.groupBy)?.id || '';
    const groups: any = _.groupBy(rows, (t) => new Date(t?.[groupId]).getFullYear());

    _.forEach(Object.keys(groups), (group: string) => {
        const groupItem: any = {};
        groupItem.rows = groups[group];
        groupItem.expanded = false;
        _.forEach(columns, (c) => {
            if (c.id === groupId) {
                groupItem.id = group;
                groupItem[groupId] = group;
            } else {
                groupItem[c.id] = groups[group].reduce((memo: any, s: any) => memo + s[c.id], 0);
            }
        });
        rowGroups.push(groupItem);
    });

    return { rowGroups };
};
